import { makeAutoObservable, runInAction } from "mobx";
import { IRootStore } from "../../../mobx/root-store.tsx";

export interface IPlaygroundUserToOrgConversionStore {
	generationsCount: number;
	shownAt10: boolean;
	shownAt50: boolean;
	shownAtExitIntent: boolean;
	incrementGenerationCount: () => void;
	markShownAt: (threshold: 10 | 50) => void;
	markExitIntentShown: () => void;
	resetStore: () => void;
}

export default class PlaygroundUserToOrgConversionStore implements IPlaygroundUserToOrgConversionStore {
	rootStore: IRootStore;
	generationsCount = 0;
	shownAt10 = false;
	shownAt50 = false;
	shownAtExitIntent = false;

	constructor(rootStore: IRootStore) {
		makeAutoObservable(this);
		this.rootStore = rootStore;
	}

	incrementGenerationCount = () => {
		const next = this.generationsCount + 1;
		runInAction(() => {
			this.generationsCount = next;
		});
	};

	markShownAt = (threshold: 10 | 50) => {
		if (threshold === 10) {
			runInAction(() => (this.shownAt10 = true));
		} else if (threshold === 50) {
			runInAction(() => (this.shownAt50 = true));
		}
	};

	markExitIntentShown = () => {
		runInAction(() => (this.shownAtExitIntent = true));
	};

	resetStore = () => {
		this.generationsCount = 0;
		this.shownAt10 = false;
		this.shownAt50 = false;
		this.shownAtExitIntent = false;
	};
}
